import { useEffect, useState } from "react";
import "./MagicBandOverlays.css";

const TRANSMIT_DURATION = 18;

const TransmittingOverlay = ({ onCancel, onClose }) => {
  const [seconds, setSeconds] = useState(TRANSMIT_DURATION);

  useEffect(() => {
    if (seconds <= 0) {
      onClose();
      return;
    }
    const timer = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds, onClose]);

  return (
    <div className="mbo-backdrop">
      <div className="mbo-card mbo-transmit">
        <div className="mbo-icon">📡</div>
        <h2 className="mbo-heading">Beacon transmitting...</h2>
        <p className="mbo-body">May take up to 20 seconds for all bands to respond</p>

        <div className="mbo-timer">{seconds}</div>

        <button className="mbo-cancel-btn" onClick={onCancel}>
          Already illuminated? Tap to pick another color!
        </button>
      </div>
    </div>
  );
};

export default TransmittingOverlay;
